import React from 'react'
import GamePassMember from './GamePassMember'

const Approvals = () => {
  return (
    <>
      <div className="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
        <div>
          <h4 className="mb-1">Approvals</h4>
          <div className="text-medium-emphasis">
            Review member verification requests and manage payment status.
          </div>
        </div>
      </div>
      <GamePassMember />
    </>
  )
}

export default Approvals
